const requests = {
  getServer: `getserver`,
  addServer: `addserver`,
  editServer: `editserver`,
  editFaq: `editfaq`,
  allFaq: `adminfaqs`,
  AllFaqtranslations: `faqstranslations`,
  addFaq: `addfaqnew`,
  getCountry: `getcountry`,
  addCountry: `addcountry`,
  editCountry: `editcountry`,
  allBlogs: `bloglist`,
  editBlogs: `editblog`,
  addBlogs: `addblog`,
  imgupload: `imgupload`,
  allFeedback: `getfeedback`,
  allFeedback1: `getfeedback1`,
  allUsers: `getusers`,
  filterUsers: `filterusers`,
  editUser: "edituser",
  adminlessoncategory: "adminlessoncategory",
  addCategory: "addCategory",
  editCategory: "editcategory",
  addCategory: "addcategory",
  allLessons: "adminlessons",
  AllLessontranslations: "lessontranslations",
  editLesson: "editLesson",
  addLesson: "addLesson",
  getcategory: "getcategory",
  allUserInterest: "userinterests",
  paypaldata: "paypaldata",
  webappdata: "getwebappdata",
  coinreport: "coinreport",
  updateFeedbackNote: "updateFeedbackNote",
  extensionsByRating: "getExtensionsByRating",
  androiddata:"androiddata",
  iosdata: "iosdata",
};

export default requests;
